import { Avatar, Button, Form, Input, Divider, Spin, message, Card, Upload } from "antd";
import Title from "antd/es/typography/Title";
import React, { useEffect, useState } from "react";
import { auth, firestore, storage } from "../../firebase";
import auditedServices from "../../servicios/empleados/serviciosAudit";
const { getEmpleadoData, cambiarPassword } = auditedServices;
import { useAuth } from "../Context";
import { useNavigate } from "react-router-dom";
import { UserOutlined, EditOutlined } from "@ant-design/icons";
import { useNotification } from "../NotificationContext";
import NoPermisos from "../NoPermisos";
// import { jwtDecode } from "jwt-decode";

const Perfil = () => {
  const navigate = useNavigate();
  const { currentUser, permisos, isAdmin, sucursal, loading } = useAuth();
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const openNotificationWithIcon = useNotification();
  // const [profile, setProfile] = useState("");
  const [empleadoData, setEmpleadoData] = useState(null);
  const [loadingEmpleado, setLoadingEmpleado] = useState(true);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  // Obtener datos completos del empleado desde la colección
  useEffect(() => {
    const fetchEmpleado = async () => {
      if (currentUser && sucursal) {
        setLoadingEmpleado(true);
        const data = await getEmpleadoData(sucursal, currentUser.uid);
        setEmpleadoData(data);
        setLoadingEmpleado(false);
        // Si hay foto, actualizar el avatar de usuario
        if (data && data.fotoUrl && currentUser.photoURL !== data.fotoUrl) {
          await currentUser.updateProfile({ photoURL: data.fotoUrl });
        }
      }
    };
    fetchEmpleado();
    // eslint-disable-next-line
  }, [currentUser, sucursal]);
  
  // const [avatarUrl, setAvatarUrl] = useState(currentUser.photoURL);

  const onFinish = async (values) => {
    try {
      setButtonDisabled(true);

      await currentUser.updateProfile({
        displayName: values.displayName,
      });

      openNotificationWithIcon(
        "success",
        "Información actualizada",
        "Se actualizó con éxito la información de perfil"
      );
      navigate("/sistema/perfil", { replace: true });
    } catch (error) {
      console.error("Error al actualizar la información del usuario:", error);
    }
    setButtonDisabled(false);
  };

    // Maneja el cambio de contraseña
  const handlePasswordChange = async (values) => {
    setPasswordLoading(true);
    try {
      const tokenValid = await auth.currentUser.getIdToken(true);
      const data = await cambiarPassword(tokenValid, currentUser.uid, values.nuevaPassword);
      if (data.success) {
        openNotificationWithIcon("success", "Contraseña actualizada", "La contraseña se actualizó correctamente");
      } else {
        openNotificationWithIcon("error", "Error", data.msg || data.message || "No se pudo actualizar la contraseña");
      }
    } catch (e) {
      openNotificationWithIcon("error", "Error", "No se pudo actualizar la contraseña");
    }
    setPasswordLoading(false);
  };

  // const handleAvatarChange = (info) => {
  //   if (info.file.estatus === "done") {
  //     // Obtener la URL de la imagen subida y actualizar el estado
  //     setAvatarUrl(info.file.response.url);
  //   }
  // };

  useEffect(() => {
  }, [isAdmin, permisos]);

  // Helper para saber si el objeto permisos está listo
  const isPermisosReady = () => {
    if (isAdmin) return true;
    if (!permisos || Object.keys(permisos).length === 0) return false;
    return true;
  };

  const hasPermisoPerfil = isAdmin || (permisos && permisos.perfil);

  if (loading || !isPermisosReady()) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <Spin size="large" tip="Cargando permisos..." />
      </div>
    );
  }
  return (
    <>
      {hasPermisoPerfil ? (
        <div style={{ maxWidth: 900, margin: "auto" }}>
          <Title level={2} className="ccg-center">Perfil</Title>
          <Divider />
          <div style={{ display: "flex", gap: 32 }}>
            {/* Info usuario a la izquierda */}
            <div style={{ flex: 1, minWidth: 260 }}>
              <Spin spinning={loadingEmpleado}>
                <Card bordered style={{ borderRadius: 12, boxShadow: '0 2px 8px #f0f1f2', padding: 0 }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 16 }}>
                    <Upload
                      showUploadList={false}
                      accept="image/*"
                      beforeUpload={() => false}
                      customRequest={async ({ file, fileList, onSuccess, onError }) => {
                        setUploading(true);
                        try {
                          // Usar originFileObj si existe (como en AgregarCapacitacion)
                          const fileToUpload = file.originFileObj || file;
                          const storageRef = storage.ref();
                          const fileRef = storageRef.child(`empleados/perfil/${currentUser.uid}/perfil.jpg`);
                          await fileRef.put(fileToUpload);
                          const url = await fileRef.getDownloadURL();
                          await firestore.collection("sucursal").doc(sucursal).collection("empleado").doc(currentUser.uid).update({ fotoUrl: url });
                          await currentUser.updateProfile({ photoURL: url });
                          setEmpleadoData((prev) => ({ ...prev, fotoUrl: url }));
                          openNotificationWithIcon("success", "Foto actualizada", "La foto de perfil se actualizó correctamente");
                          if (onSuccess) onSuccess();
                        } catch (err) {
                          console.error('[Perfil] Error al subir imagen:', err);
                          openNotificationWithIcon("error", "Error", err.message || "No se pudo actualizar la foto de perfil");
                          if (onError) onError(err);
                        }
                        setUploading(false);
                      }}
                    >
                      <div style={{ position: 'relative', display: 'inline-block' }}>
                        <Avatar
                          src={empleadoData?.fotoUrl || currentUser.photoURL}
                          size={92}
                          icon={<UserOutlined />}
                          style={{ cursor: 'pointer', border: uploading ? '2px solid #1890ff' : undefined, transition: 'border 0.2s' }}
                        />
                        {/* Icono de editar sobre el avatar al hacer hover */}
                        <div
                          style={{
                            position: 'absolute',
                            right: 0,
                            bottom: 0,
                            background: '#fff',
                            borderRadius: '50%',
                            boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
                            padding: 4,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            opacity: 0.85,
                            transition: 'opacity 0.2s',
                            pointerEvents: 'none',
                          }}
                          className="avatar-edit-icon"
                        >
                          <EditOutlined style={{ color: '#1890ff', fontSize: 18 }} />
                        </div>
                        <style>{`
                          .ant-upload-wrapper:hover .avatar-edit-icon {
                            opacity: 1 !important;
                            pointer-events: auto !important;
                          }
                        `}</style>
                      </div>
                    </Upload>
                    <div style={{ marginTop: 16, fontSize: 18, fontWeight: 500 }}>
                      {empleadoData ? `${empleadoData.nombre || ''} ${empleadoData.ap_paterno || ''} ${empleadoData.ap_materno || ''}`.trim() : currentUser.displayName}
                    </div>
                    <div style={{ color: '#888', fontSize: 14 }}>{empleadoData?.correo || currentUser.email}</div>
                  </div>
                  <Divider style={{ margin: '12px 0' }} />
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10, fontSize: 15 }}>
                    {empleadoData && (
                      <>
                        <div><b>Puesto:</b> {empleadoData.puesto || '-'}</div>
                        <div><b>Teléfono:</b> {empleadoData.celular || '-'}</div>
                        {empleadoData.genero && <div><b>Género:</b> {empleadoData.genero}</div>}
                        {empleadoData.edad && <div><b>Edad:</b> {empleadoData.edad}</div>}
                        {empleadoData.fecha_ingreso && <div><b>Fecha de ingreso:</b> {empleadoData.fecha_ingreso}</div>}
                        {empleadoData.fecha_nacimiento && <div><b>Fecha de nacimiento:</b> {empleadoData.fecha_nacimiento}</div>}
                        {empleadoData.estatus && <div><b>Estatus:</b> {empleadoData.estatus}</div>}
                        {/* Mostrar áreas solo si existen y tienen elementos */}
                        {Array.isArray(empleadoData.areas) && empleadoData.areas.length > 0 && (
                          <div>
                            <b>Áreas:</b>
                            <ul style={{ margin: 0, paddingLeft: 20 }}>
                              {empleadoData.areas.map((area, idx) => (
                                <li key={idx}>{area}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                        <div><b>Sucursal:</b> {sucursal || '-'}</div>
                      </>
                    )}
                  </div>
                </Card>
              </Spin>
            </div>
            {/* Formulario contraseña a la derecha */}
            <div style={{ flex: 1, minWidth: 320 }}>
              <Divider orientation="left">Actualizar contraseña</Divider>
              <Form
                name="passwordForm"
                layout="vertical"
                onFinish={handlePasswordChange}
              >
                <Form.Item
                  label="Nueva contraseña"
                  name="nuevaPassword"
                  rules={[
                    { required: true, message: "Ingresa la nueva contraseña" },
                    { min: 6, message: "Mínimo 6 caracteres" },
                  ]}
                  hasFeedback
                >
                  <Input.Password onChange={e => {
                    // Forzar revalidación del campo de confirmación
                    if (e && e.target && e.target.form) {
                      const form = e.target.form;
                      if (form) {
                        const confirmInput = form.querySelector('[name="confirmPassword"]');
                        if (confirmInput) confirmInput.dispatchEvent(new Event('input', { bubbles: true }));
                      }
                    }
                  }} />
                </Form.Item>
                <Form.Item
                  label="Confirmar contraseña"
                  name="confirmPassword"
                  dependencies={["nuevaPassword"]}
                  hasFeedback
                  rules={[
                    { required: true, message: "Confirma la nueva contraseña" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("nuevaPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Las contraseñas no coinciden"));
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit" loading={passwordLoading}>Actualizar contraseña</Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      ) : (
        <NoPermisos />
      )}
    </>
  );
};

export default Perfil;
